/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SDApplicationForm' store object.
 * @namespace SDApplicationFormSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASDApplicationForm';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationFormSelectors
   */
  static postSdApplications = state => state[selectors.moduleIdentifier].postSdApplications.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationFormSelectors
   */
  static isFetchingPostSdApplications = state =>
    state[selectors.moduleIdentifier].isFetchingPostSdApplications.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDApplicationFormSelectors
   */
  static postSdApplicationsError = state =>
    state[selectors.moduleIdentifier].postSdApplicationsError.payload;
}
